import * as Yup from 'yup';

const validateUniqueAgents = (value: any) => {
  if (!value) return true;

  const anyNullorNaN = value?.some((item: any) => item.agentId === null);
  if (anyNullorNaN) return true;

  const agentIds = new Set();
  return value
    ?.map((split: { agentId: any }) => split.agentId)
    .every((id: any) => {
      if (agentIds?.has(id)) {
        return false;
      }
      agentIds.add(id);
      return true;
    });
};

const UniqueAgentSchema = Yup.array().test(
  'unique-agentIds',
  'An agent can not be selected on more than one row.',
  validateUniqueAgents
);

export default UniqueAgentSchema;
